const routes = [
  {
    path: '/',
    redirect: { name: 'viajes-ride-list' },
    name: 'dashboard'
  }
]

export default routes
